import { render, staticRenderFns } from "./configureIcon.vue?vue&type=template&id=4ed93420&"
import script from "./configureIcon.vue?vue&type=script&lang=js&"
export * from "./configureIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports